export const recordShipmentVisitTimeEndpoint = (shipmentUid: string, visitId: string) =>
  `/shipments/${shipmentUid}/visits/${visitId}/record-time`
